import './style.css'
import Slider from "../Slider";

export default class Offices {
    static selector = '.offices'

    constructor(block) {
        this.block = block
    }

    onComplete() {
        const officesPhones = this.block.querySelectorAll('.offices__phone');

        new Slider({
            container: this.block.querySelector('#offices-slider'),
            controlsContainer: this.block.querySelector('.offices__slider-nav'),
            responsive: {
                765: {
                    items: 2,
                },
                1025: {
                    autoplay: true,
                    autoplayButton: false,
                    items: 4,
                    gutter: 30,
                }
            }
        })
    }
}
